import { render, staticRenderFns } from "./TouchInBagPublicView.vue?vue&type=template&id=63299169&scoped=true"
import script from "./TouchInBagPublicView.vue?vue&type=script&lang=js"
export * from "./TouchInBagPublicView.vue?vue&type=script&lang=js"
import style0 from "./TouchInBagPublicView.vue?vue&type=style&index=0&id=63299169&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63299169",
  null
  
)

export default component.exports